import React from "react";
import Nav from "../Nav";
import "./style.css";

function COFormB({ data }) {
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n        <!--\n        span.cls_008 {\n            font-family: Times, serif;\n            font-size: 14.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: underline\n        }\n\n .newtext{border: none; background: transparent;}        div.cls_008 {\n            font-family: Times, serif;\n            font-size: 14.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_006 {\n            font-family: Times, serif;\n            font-size: 11.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_006 {\n            font-family: Times, serif;\n            font-size: 11.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_004 {\n            font-family: Times, serif;\n            font-size: 11.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_004 {\n            font-family: Times, serif;\n            font-size: 11.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        span.cls_007 {\n            font-family: Times, serif;\n            font-size: 9.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n\n        div.cls_007 {\n            font-family: Times, serif;\n            font-size: 9.1px;\n            color: rgb(0, 0, 0);\n            font-weight: bold;\n            font-style: normal;\n            text-decoration: none\n        }\n        .dotted {\n            border:0;\n            border-bottom: 2px dotted;\n            \n        }\n        .uploader {width:300px;height:350px;background:#f3f3f3;border:2px dashed #e8e8e8;}\n        \n    ",
        }}
      />
      <div
        style={{
          border: "solid black 4px",
          position: "absolute",
          left: "50%",
          marginLeft: "-297px",
          top: "100px",
          width: "620px",
          height: "900px",
          overflow: "hidden",
        }}
      >
        <div style={{ position: "absolute", left: "0px", top: "0px" }}>
          <img
            src={require("./54066808-eadb-11ea-8b25-0cc47a792c0a_id_54066808-eadb-11ea-8b25-0cc47a792c0a_files/background1.jpg")}
            width={595}
            height={841}
          />
        </div>
        <div
          style={{ position: "absolute", left: "263.09px", top: "67.12px" }}
          className="cls_008"
        >
          <span className="cls_008">FORM “B”</span>
        </div>
        <div
          style={{ position: "absolute", left: "399.82px", top: "86.10px" }}
          className="cls_006"
        >
          <span className="cls_006">
            Date
            <input
              disabled
              value={
                data.ApprovedDate.toDate().getFullYear().toString() +
                "-" +
                ((data.ApprovedDate.toDate().getMonth() + 1).toString()
                  .length == 1
                  ? "0"
                  : "") +
                (data.ApprovedDate.toDate().getMonth() + 1).toString() +
                "-" +
                data.ApprovedDate.toDate().getDate().toString()
              }
              type="text"
              id="Date"
              className="newtext"
              size={10}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "100.14px" }}
          className="cls_004"
        >
          <span className="cls_004">Secretary General</span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "112.86px" }}
          className="cls_004"
        >
          <span className="cls_004">
            Federation of Chambers of Commerce &amp; Industry of Sri Lanka
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "398.35px", top: "118.02px" }}
          className="cls_006"
        >
          <span className="cls_006">
            Ref No.
            <input
              disabled
              value={data.RefNo}
              type="text"
              id="RefNo"
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "125.46px" }}
          className="cls_004"
        >
          <span className="cls_004">"Federation House"</span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "138.06px" }}
          className="cls_004"
        >
          <span className="cls_004">
            No : 17/1,1st Lane Gothami Road , Colombo 08, Sri Lanka
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "163.38px" }}
          className="cls_004"
        >
          <span className="cls_004">Dear Sir,</span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "201.30px" }}
          className="cls_004"
        >
          <span className="cls_004">
            We enclose a copy of the Certificate of Origin and Invoice relating
            to the shipment details as set out below.
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "392.47px", top: "233.46px" }}
          className="cls_004"
        >
          <span className="cls_004">Vessel &amp;</span>
        </div>
        <div
          style={{ position: "absolute", left: "79.70px", top: "239.82px" }}
          className="cls_004"
        >
          <span className="cls_004">Item Exported</span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "285.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.ContainerNo1}
              type="text"
              id="ItemExported1"
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "310.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.ContainerNo2}
              type="text"
              id="ItemExported2"
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "335.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported3"
              value={data.ContainerNo3}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "360.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported4"
              value={data.ContainerNo4}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "385.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported5"
              value={data.ContainerNo5}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "410.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported6"
              value={data.ContainerNo6}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "435.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported7"
              value={data.ContainerNo7}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "460.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported8"
              value={data.ContainerNo8}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "485.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported9"
              value={data.ContainerNo9}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "49.70px", top: "510.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              type="text"
              id="ItemExported10"
              value={data.ContainerNo10}
              className="newtext"
              size={15}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "203.21px", top: "239.82px" }}
          className="cls_004"
        >
          <span className="cls_004">Quantity</span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "285.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity1}
              type="text"
              id="Quantity1"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "310.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity2}
              type="text"
              id="Quantity2"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "335.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity3}
              type="text"
              id="Quantity3"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "360.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity4}
              type="text"
              id="Quantity4"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "385.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity5}
              type="text"
              id="Quantity5"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "410.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity6}
              type="text"
              id="Quantity6"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "435.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity7}
              type="text"
              id="Quantity7"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "460.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity8}
              type="text"
              id="Quantity8"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "485.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity9}
              type="text"
              id="Quantity9"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "191.21px", top: "510.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Quantity10}
              type="text"
              id="Quantity10"
              className="newtext"
              size={6}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "277.13px", top: "239.82px" }}
          className="cls_004"
        >
          <span className="cls_004">Marks &amp; Nos.</span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "285.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks1}
              type="text"
              id="Marks1"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "310.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks2}
              type="text"
              id="Marks2"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "335.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks3}
              type="text"
              id="Marks3"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "360.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks4}
              type="text"
              id="Marks4"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "385.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks5}
              type="text"
              id="Marks5"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "410.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks6}
              type="text"
              id="Marks6"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "435.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks7}
              type="text"
              id="Marks7"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "460.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks8}
              type="text"
              id="Marks8"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "485.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks9}
              type="text"
              id="Marks9"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "260.00px", top: "510.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Marks10}
              type="text "
              id="Marks10"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "489.58px", top: "239.82px" }}
          className="cls_004"
        >
          <span className="cls_004">Destination</span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "285.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination1}
              type="text"
              id="Destination1"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "310.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination2}
              type="text"
              id="Destination2"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "335.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination3}
              type="text"
              id="Destination3"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "360.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination4}
              type="text"
              id="Destination4"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "385.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination5}
              type="text"
              id="Destination5"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "410.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination6}
              type="text"
              id="Destination6"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "435.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination7}
              type="text"
              id="Destination7"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "460.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination8}
              type="text"
              id="Destination8"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "485.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination9}
              type="text"
              id="Destination9"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "465.00px", top: "510.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.Destination10}
              type="text "
              id="Destination10"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "386.35px", top: "246.18px" }}
          className="cls_004"
        >
          <span className="cls_004">Sailing Sate</span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "285.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate1}
              type="text"
              id="SailingSate1"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "310.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate2}
              type="text"
              id="SailingSate2"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "335.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate3}
              type="text"
              id="SailingSate3"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "360.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate4}
              type="text"
              id="SailingSate4"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "385.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate5}
              type="text"
              id="SailingSate5"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "410.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate6}
              type="text"
              id="SailingSate6"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "435.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate7}
              type="text"
              id="SailingSate7"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "460.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate8}
              type="text"
              id="SailingSate8"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "485.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate9}
              type="text"
              id="SailingSate9"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "363.00px", top: "510.82px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.SailingSate10}
              type="text "
              id="SailingSate10"
              className="newtext"
              size={12}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "591.95px" }}
          className="cls_004"
        >
          <span className="cls_004">
            We hereby certify that the particulars set out above are correct and
            that the item exported has been produced /
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "604.67px" }}
          className="cls_004"
        >
          <span className="cls_004">manufactured in Sri Lanka.</span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "629.99px" }}
          className="cls_004"
        >
          <span className="cls_004">
            We hereby undertake to indemnify the Federation of Chambers of
            Commerce &amp; Industry of Sri Lanka for any
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "642.62px" }}
          className="cls_004"
        >
          <span className="cls_004">
            damages it may incur in signing the above document.
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "667.94px" }}
          className="cls_004"
        >
          <span className="cls_004">Yours faithfully,</span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "690.94px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <img
              id="blah2"
              src={data.companyseal}
              width="150px"
              height="75px"
              alt="your image"
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "43.20px", top: "790.78px" }}
          className="cls_004"
        >
          <span className="cls_004">Signature of Exporter / Agent</span>
        </div>
        <div
          style={{ position: "absolute", left: "300.00px", top: "680.78px" }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.OfficerName}
              type="text"
              id="OfficerName"
              className="newtext"
              size={40}
              style={{ textAlign: "center" }}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "356.00px", top: "705.70px" }}
          className="cls_004"
        >
          <span className="cls_004">Name &amp; Designation of Officer</span>
        </div>
        <div
          style={{
            position: "absolute",
            left: "300.00px",
            top: "759.78px",
            textAlign: "center",
          }}
          className="cls_004"
        >
          <span className="cls_004">
            <input
              disabled
              value={data.CompanyName}
              type="text"
              id="CompanyName"
              className="newtext"
              size={40}
              style={{ textAlign: "center" }}
            />
          </span>
        </div>
        <div
          style={{ position: "absolute", left: "403.30px", top: "781.70px" }}
          className="cls_004"
        >
          <span className="cls_004">Company</span>
        </div>
        <div
          style={{ position: "absolute", left: "162.35px", top: "808.22px" }}
          className="cls_007"
        ></div>
        <div
          style={{ position: "absolute", left: "362.35px", top: "808.22px" }}
          className="cls_007"
        >
          <span className="cls_007">This is a computer generated document</span>
        </div>
      </div>
    </div>
  );
}

export default COFormB;
